/**
 * Kamus namespace `kesehatan` — indikator status jaringan & printer di layar kasir.
 *
 * ⭐ Ini penerapan **R2 (§10b): kegagalan WAJIB TERLIHAT.** Tiket dapur yang hilang karena
 * timeout adalah kegagalan senyap paling mahal di jam sibuk — kasir mengira pesanan terkirim,
 * dapur tak pernah menerimanya, dan yang pertama tahu adalah tamu yang menunggu.
 */
export const healthId = {
  title: 'Status',
  server: 'Server',
  kitchenPrinter: 'Printer',
  queue: 'Antrean',
  status: {
    healthy: 'Normal',
    slow: 'Lambat',
    down: 'Terputus',
    checking: 'Memeriksa…',
  },
  /* ⛔ "Perlu ditinjau", bukan "gagal": yang ini menunggu ORANG, dan kata "gagal" membuat orang
     menunggu sistem memperbaikinya sendiri — padahal ia tak akan pernah. */
  review: 'Perlu ditinjau',
  reviewHeld: '{{n}} transaksi ditolak portal',
  queueHeld: '{{n}} menunggu kirim',
  lastOk: 'Terakhir berhasil {{time}}',
  offline: 'Mode luring — transaksi tetap tersimpan dan akan dikirim otomatis',
  /* ⛔ Dipakai saat perangkat ini TIDAK punya antrean luring: menjanjikan "tersimpan" di situ
     berarti berbohong tentang uang. Kalimatnya menyebut apa yang MASIH bisa dikerjakan. */
  offlineNoQueue:
    'Server tak terjangkau — bill baru belum bisa diselesaikan di terminal ini. '
    + 'Bill yang sudah lunas aman; tunggu server kembali atau pakai till lain.',
  /* ⚠️ Menyebut AGEN, bukan cuma "printer": yang paling sering diam bukan printernya melainkan
     agen cetak di mesin ini — dan dua sebab itu ditangani orang yang berbeda. */
  installAgent: 'PASANG AGEN',
  printerRejected: 'Agen menolak alamat ini. Isi di agen:',
  printerUnpaired: 'Printer belum di-pair (Setelan → Bluetooth).',
  printerOff: 'Agen cetak tak ada.',
};
export const healthEn: typeof healthId = {
  title: 'Status',
  server: 'Server',
  kitchenPrinter: 'Printer',
  queue: 'Queue',
  status: {
    healthy: 'Healthy',
    slow: 'Slow',
    down: 'Disconnected',
    checking: 'Checking…',
  },
  review: 'Needs review',
  reviewHeld: '{{n}} rejected by portal',
  queueHeld: '{{n}} pending',
  lastOk: 'Last success {{time}}',
  offline: 'Offline mode — transactions are still saved and will sync automatically',
  offlineNoQueue:
    'Server unreachable — new bills cannot be completed on this terminal. '
    + 'Bills already paid are safe; wait for the server or use another till.',
  installAgent: 'INSTALL AGENT',
  printerRejected: 'Agent rejected this address. Set it in the agent:',
  printerUnpaired: 'No printer paired (Settings → Bluetooth).',
  printerOff: 'Print agent missing.',
};
